(function () {
  var STORAGE_KEY = 'excelQuickShopList';
  var MAX_QUANTITY = 999999;

  function initQuickShop(section) {
    var data = section.dataset;
    var resultsWrap = section.querySelector('[data-qs-results-wrap]');
    var countLabel = section.querySelector('[data-qs-count]');
    var nav = section.querySelector('[data-qs-nav]');
    var sidebar = section.querySelector('[data-qs-sidebar]');
    var scrim = section.querySelector('.eqs__scrim');
    var openCategories = section.querySelector('[data-qs-open-categories]');
    var closeCategoriesButton = section.querySelector('.eqs__sidebar-close');
    var triggerLabel = section.querySelector('[data-qs-trigger-label]');
    var searchForm = section.querySelector('[data-qs-search-form]');
    var searchInput = section.querySelector('[data-qs-search]');
    var searchClear = section.querySelector('[data-qs-search-clear]');
    var bar = section.querySelector('[data-qs-bar]');
    var barLines = section.querySelector('[data-qs-bar-lines]');
    var barLabel = section.querySelector('[data-qs-bar-label]');
    var barTotal = section.querySelector('[data-qs-bar-total]');
    var reviewButton = section.querySelector('[data-qs-review]');
    var reviewPanel = section.querySelector('[data-qs-review-panel]');
    var reviewList = section.querySelector('[data-qs-review-list]');
    var clearButton = section.querySelector('[data-qs-clear]');
    var addAllButton = section.querySelector('[data-qs-add-all]');
    var checkoutButton = section.querySelector('[data-qs-checkout]');
    var message = section.querySelector('[data-qs-message]');

    var list = readList();
    var initialResults = resultsWrap.querySelector('[data-qs-results]');
    var current = { source: initialResults ? initialResults.dataset.source : '', query: '' };
    var lastCategory = current.source;
    var loading = null;
    var more = null;
    var moreObserver = null;
    var moreLoading = null;
    var searchTimer = null;
    var busy = false;
    var previousOverflow = '';

    // ---- Formatting -------------------------------------------------------------------------

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency || 'USD' }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function plural(count, one, many) {
      return count === 1 ? one : many.replace('[count]', count.toLocaleString());
    }

    function label(template, title) {
      return (template || '').replace('[title]', title);
    }

    // ---- The order list ---------------------------------------------------------------------
    // Quantities live in one list keyed by variant, saved in the browser so switching categories,
    // reloading or opening another tab keeps them until they're added to the cart.

    // Only trade accounts order wire and cable, so wire saved while signed in to one drops off the list
    // once the visitor is signed out (or signed in without one).
    function readList() {
      try {
        var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
        var clean = {};
        Object.keys(stored).forEach(function (id) {
          var item = stored[id];
          if (item && item.wire && data.tradeAccount !== 'true') return;
          if (item && /^\d+$/.test(id) && Number(item.qty) > 0 && Number.isFinite(Number(item.price))) clean[id] = item;
        });
        return clean;
      } catch (error) {
        return {};
      }
    }

    function saveList() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (error) { /* Private windows can refuse storage; the list still works for this visit. */ }
    }

    function rowData(row) {
      var max = row.dataset.max;
      return {
        id: row.dataset.variantId,
        title: row.dataset.title,
        url: row.dataset.url,
        image: row.dataset.image,
        sku: row.dataset.sku,
        price: Number(row.dataset.price) || 0,
        unit: row.dataset.unit,
        min: Math.max(1, Number(row.dataset.min) || 1),
        step: Math.max(1, Number(row.dataset.step) || 1),
        buttonStep: Math.max(1, Number(row.dataset.buttonStep) || 1),
        start: Math.max(1, Number(row.dataset.start) || 1),
        max: max === '' || max === undefined ? null : Math.max(0, Number(max)),
        wire: row.dataset.wire === 'true'
      };
    }

    function itemFor(id) {
      if (list[id]) return list[id];
      var row = section.querySelector('[data-qs-row][data-variant-id="' + id + '"]');
      return row ? rowData(row) : null;
    }

    // Snap to the variant's quantity rules (minimum, increment and stock limit).
    function fit(item, quantity) {
      if (!(quantity > 0)) return { qty: 0, limited: false };
      var min = item.min || 1;
      var step = item.step || 1;
      var qty = Math.max(min, Math.round(quantity));
      if (step > 1) qty = min + Math.ceil((qty - min) / step) * step;
      var limited = false;
      var max = item.max === null || item.max === undefined ? MAX_QUANTITY : Math.min(item.max, MAX_QUANTITY);
      if (qty > max) {
        qty = step > 1 ? min + Math.floor((max - min) / step) * step : max;
        limited = true;
      }
      return { qty: qty >= min ? qty : 0, limited: limited };
    }

    function setQuantity(id, quantity, options) {
      var item = itemFor(id);
      if (!item) return 0;
      var result = fit(item, quantity);
      if (result.qty > 0) {
        item.qty = result.qty;
        item.added = item.added || Date.now();
        delete item.cuts;
        list[id] = item;
      } else {
        delete list[id];
      }
      saveList();
      hideMessage();
      syncRows(id, options && options.keepInput, result.limited);
      renderBar();
      if (!reviewPanel.hidden) renderReview(options && options.keepInput ? id : null);
      return result.qty;
    }

    function totalCents() {
      return Object.keys(list).reduce(function (sum, id) { return sum + list[id].price * list[id].qty; }, 0);
    }

    // ---- Rows -------------------------------------------------------------------------------

    function syncRow(row, keepInput, limited) {
      var id = row.dataset.variantId;
      var stepper = row.querySelector('[data-qs-stepper]');
      if (!stepper) return;
      var item = list[id];
      // Rows carry the current price and stock, so a saved item picks them up when its row shows.
      if (item) {
        var fresh = rowData(row);
        ['title', 'url', 'image', 'sku', 'price', 'unit', 'min', 'step', 'buttonStep', 'start', 'max', 'wire'].forEach(function (key) { item[key] = fresh[key]; });
        var fitted = fit(item, item.qty);
        if (!item.cuts && fitted.qty !== item.qty) {
          limited = fitted.limited;
          if (fitted.qty > 0) item.qty = fitted.qty;
          else {
            delete list[id];
            item = null;
          }
        }
      }
      var qty = item ? item.qty : 0;
      var input = row.querySelector('[data-qs-input]');
      var total = row.querySelector('[data-qs-line-total]');
      var minus = row.querySelector('[data-qs-step="-1"]');
      var plus = row.querySelector('[data-qs-step="1"]');
      var limit = row.querySelector('[data-qs-limit]');
      if (!keepInput || document.activeElement !== input) input.value = String(qty);
      sizeInput(input);
      input.classList.toggle('is-zero', qty === 0);
      input.removeAttribute('aria-invalid');
      row.classList.toggle('is-selected', qty > 0);
      total.textContent = qty ? money(rowData(row).price * qty) : '';
      // Wire shows its total footage under the line total.
      var feet = row.querySelector('[data-qs-line-feet]');
      if (feet) feet.textContent = qty ? qty.toLocaleString() + ' ft' : '';
      var max = rowData(row).max;
      minus.disabled = qty === 0;
      plus.disabled = max !== null && qty >= max;
      if (limit) {
        limit.hidden = !limited;
        limit.textContent = limited ? data.labelMax.replace('[count]', String(max)) : '';
      }
      syncCuts(row, item);
    }

    // ---- Splicing ---------------------------------------------------------------------------
    // Wire sold by the foot can be split into cuts, as on the wiring collection. The splice button
    // opens a draft card, and nothing changes on the list until Add to list (Cancel or Esc drops the
    // draft). Saved cuts show as a "3 cuts · 275 ft" chip in place of the stepper; the chip reopens
    // them and its × takes the wire off the list. Each cut becomes its own cart line.

    // Footage boxes fit their number, so "100" and "ft" sit together in the middle of the stepper.
    function sizeInput(input) {
      if (!input.parentNode.querySelector('.eqs-stepper__unit')) return;
      input.style.width = (Math.max(1, input.value.length) + 0.3) + 'ch';
    }

    function wholeFeet(value) {
      var text = String(value || '').trim();
      if (!/^[1-9][0-9]*$/.test(text)) return 0;
      var amount = Number(text);
      return Number.isSafeInteger(amount) && amount <= 100000 ? amount : 0;
    }

    function cutInputs(row) {
      return Array.prototype.slice.call(row.querySelectorAll('[data-qs-cut-input]'));
    }

    function sum(lengths) {
      return lengths.reduce(function (total, length) { return total + length; }, 0);
    }

    // Empty fields are skipped; anything else that isn't a whole number of feet is flagged.
    function readCuts(row) {
      var lengths = [];
      var valid = true;
      cutInputs(row).forEach(function (input) {
        if (input.value === '') {
          input.removeAttribute('aria-invalid');
          return;
        }
        var length = wholeFeet(input.value);
        if (length) {
          input.removeAttribute('aria-invalid');
          lengths.push(length);
        } else {
          input.setAttribute('aria-invalid', 'true');
          valid = false;
        }
      });
      return { lengths: lengths, valid: valid };
    }

    function cutsText(lengths) {
      return plural(lengths.length, data.labelCutsOne, data.labelCutsMany) + ' · ' + sum(lengths).toLocaleString() + ' ft';
    }

    function labelCuts(row) {
      var splice = row.querySelector('[data-qs-splice]');
      var inputs = cutInputs(row);
      inputs.forEach(function (input, index) {
        var field = input.closest('.eqs-splice__cut');
        var number = String(index + 1);
        field.querySelector('.eqs-splice__label').textContent = data.labelCut.replace('[n]', number);
        var remove = field.querySelector('[data-qs-cut-remove]');
        remove.setAttribute('aria-label', data.labelRemoveCut.replace('[n]', number));
        remove.hidden = inputs.length <= 1;
      });
      row.querySelector('[data-qs-splice-add]').hidden = inputs.length >= (Number(splice.dataset.maxCuts) || 25);
    }

    function addCutField(row, value) {
      var field = document.createElement('div');
      field.className = 'eqs-splice__cut';
      field.innerHTML = '<label class="eqs-splice__field"><span class="eqs-splice__label"></span>' +
        '<input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="off" data-qs-cut-input>' +
        '<span class="eqs-splice__unit" aria-hidden="true">ft</span></label>' +
        '<button type="button" class="eqs-splice__remove" data-qs-cut-remove tabindex="-1">' + svg('M18 6 6 18M6 6l12 12') + '</button>';
      var input = field.querySelector('input');
      input.value = value ? String(value) : '';
      row.querySelector('[data-qs-splice-cuts]').appendChild(field);
      return input;
    }

    // Saved cuts swap the stepper for the chip.
    function syncCuts(row, item) {
      var chip = row.querySelector('[data-qs-cuts]');
      if (!chip) return;
      var spliced = Boolean(item && item.cuts);
      chip.hidden = !spliced;
      row.querySelector('[data-qs-stepper]').hidden = spliced;
      if (spliced) chip.querySelector('[data-qs-cuts-edit]').textContent = cutsText(item.cuts);
    }

    // The card's footer shows the draft's total, or why it can't be added yet.
    function updateSplice(row) {
      var id = row.dataset.variantId;
      var state = readCuts(row);
      var base = itemFor(id);
      var total = sum(state.lengths);
      var tooMany = base && base.max !== null && base.max !== undefined && total > base.max;
      var summary = row.querySelector('[data-qs-splice-summary]');
      summary.classList.toggle('is-error', Boolean(tooMany));
      summary.textContent = tooMany ? data.labelMaxFeet.replace('[count]', String(base.max)) : state.lengths.length && base ? cutsText(state.lengths) + ' · ' + money(base.price * total) : '';
      var save = row.querySelector('[data-qs-splice-save]');
      save.disabled = !state.valid || !state.lengths.length || Boolean(tooMany);
      save.textContent = list[id] && list[id].cuts ? save.dataset.updateLabel : save.dataset.addLabel;
    }

    function setSpliceOpen(row, open) {
      row.querySelector('[data-qs-splice]').hidden = !open;
      row.classList.toggle('is-splicing', open);
      row.querySelectorAll('[data-qs-splice-toggle], [data-qs-cuts-edit]').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (!open) row.querySelector('[data-qs-splice-cuts]').innerHTML = '';
    }

    // The draft starts from the saved cuts, or the current footage split in half (250 ft becomes
    // 125 + 125), or two empty cuts.
    function openSplice(row) {
      var item = list[row.dataset.variantId];
      var qty = item ? item.qty : 0;
      var values = item && item.cuts ? item.cuts.slice() : qty ? [Math.ceil(qty / 2), Math.floor(qty / 2)] : ['', ''];
      row.querySelector('[data-qs-splice-cuts]').innerHTML = '';
      values.forEach(function (value) { addCutField(row, value); });
      labelCuts(row);
      setSpliceOpen(row, true);
      updateSplice(row);
      var splice = row.querySelector('[data-qs-splice]');
      if (splice.animate && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        splice.animate([
          { opacity: 0, transform: 'translateY(-6px) scale(.97)' },
          { opacity: 1, transform: 'none' }
        ], { duration: 320, easing: 'cubic-bezier(.05, .7, .1, 1)' });
      }
      var inputs = cutInputs(row);
      var first = inputs.filter(function (input) { return input.value === ''; })[0] || inputs[0];
      if (first) first.focus({ preventScroll: true });
      // Bring the whole card, down to Add to list, into view above the floating order bar.
      splice.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function closeSplice(row) {
      setSpliceOpen(row, false);
      var item = list[row.dataset.variantId];
      (item && item.cuts ? row.querySelector('[data-qs-cuts-edit]') : row.querySelector('[data-qs-splice-toggle]')).focus();
    }

    // Add to list: one cut is a plain length; two or more are kept as cuts.
    function saveSplice(row) {
      updateSplice(row);
      if (row.querySelector('[data-qs-splice-save]').disabled) return;
      var id = row.dataset.variantId;
      var lengths = readCuts(row).lengths;
      if (lengths.length === 1) {
        setQuantity(id, lengths[0]);
      } else {
        var base = itemFor(id);
        base.cuts = lengths;
        base.qty = sum(lengths);
        base.added = base.added || Date.now();
        list[id] = base;
        saveList();
        hideMessage();
        syncRows(id);
        renderBar();
        if (!reviewPanel.hidden) renderReview();
      }
      closeSplice(row);
    }

    function syncRows(id, keepInput, limited) {
      section.querySelectorAll('[data-qs-row][data-variant-id="' + id + '"]').forEach(function (row) { syncRow(row, keepInput, limited); });
    }

    function syncAllRows() {
      resultsWrap.querySelectorAll('[data-qs-row]').forEach(function (row) { syncRow(row); });
      saveList();
    }

    // ---- Order bar and review list ----------------------------------------------------------

    function orderedIds() {
      return Object.keys(list).sort(function (a, b) { return (list[a].added || 0) - (list[b].added || 0); });
    }

    function renderBar() {
      var ids = Object.keys(list);
      var hasItems = ids.length > 0;
      if (!hasItems && !reviewPanel.hidden) toggleReview(false);
      bar.hidden = !hasItems;
      section.classList.toggle('has-bar', hasItems);
      if (!hasItems) return;
      barLines.textContent = ids.length.toLocaleString();
      barLabel.textContent = plural(ids.length, data.labelLinesOne, data.labelLinesMany);
      barTotal.textContent = money(totalCents());
    }

    function svg(path) {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="' + path + '"/></svg>';
    }

    function reviewLine(id) {
      var item = list[id];
      var line = document.createElement('li');
      line.className = 'eqs-line';
      line.dataset.variantId = id;

      var image = document.createElement('a');
      image.className = 'eqs-line__image';
      image.href = item.url || '#';
      image.tabIndex = -1;
      image.setAttribute('aria-hidden', 'true');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 44;
        img.height = 44;
        image.appendChild(img);
      }

      var copy = document.createElement('div');
      copy.className = 'eqs-line__copy';
      var name = document.createElement('a');
      name.className = 'eqs-line__name';
      name.href = item.url || '#';
      name.textContent = item.title;
      var meta = document.createElement('small');
      meta.textContent = [item.sku ? '#' + item.sku : '', money(item.price) + (item.unit === 'ft' ? data.labelPerFoot : data.labelEach)].filter(Boolean).join(' · ');
      copy.appendChild(name);
      copy.appendChild(meta);

      if (item.cuts) meta.textContent = [item.sku ? '#' + item.sku : '', item.cuts.join(', ') + ' ft'].filter(Boolean).join(' · ');
      var stepper = document.createElement('div');
      stepper.className = 'eqs-stepper';
      stepper.innerHTML = '<button type="button" class="eqs-stepper__step" data-qs-step="-1">' + svg('M5 12h14') + '</button>' +
        '<label class="eqs-stepper__field"><span class="visually-hidden"></span><input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" autocomplete="off" data-qs-input>' +
        (item.unit === 'ft' ? '<span class="eqs-stepper__unit" aria-hidden="true">ft</span>' : '') + '</label>' +
        '<button type="button" class="eqs-stepper__step" data-qs-step="1">' + svg('M12 5v14M5 12h14') + '</button>';
      stepper.querySelector('[data-qs-step="-1"]').setAttribute('aria-label', label(data.labelDecrease, item.title));
      stepper.querySelector('[data-qs-step="1"]').setAttribute('aria-label', label(data.labelIncrease, item.title));
      stepper.querySelector('.visually-hidden').textContent = label(data.labelQuantity, item.title);
      stepper.querySelector('input').value = String(item.qty);
      sizeInput(stepper.querySelector('input'));
      stepper.querySelector('[data-qs-step="1"]').disabled = item.max !== null && item.max !== undefined && item.qty >= item.max;

      var total = document.createElement('span');
      total.className = 'eqs-line__total';
      total.textContent = money(item.price * item.qty);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'eqs-line__remove';
      remove.setAttribute('data-qs-remove', '');
      remove.setAttribute('aria-label', label(data.labelRemove, item.title));
      remove.innerHTML = svg('M18 6 6 18M6 6l12 12');

      if (item.cuts) {
        stepper = document.createElement('span');
        stepper.className = 'eqs-qty__cuts';
        stepper.textContent = cutsText(item.cuts);
      }
      line.appendChild(image);
      line.appendChild(copy);
      line.appendChild(stepper);
      line.appendChild(total);
      line.appendChild(remove);
      return line;
    }

    // Rebuilds the list; the line being typed in keeps its input so the caret doesn't jump.
    function renderReview(typingId) {
      var focused = document.activeElement;
      var focusId = focused && reviewList.contains(focused) ? focused.closest('[data-variant-id]').dataset.variantId : null;
      var focusSelector = focused && focused.hasAttribute('data-qs-step') ? '[data-qs-step="' + focused.dataset.qsStep + '"]' : focused && focused.hasAttribute('data-qs-remove') ? '[data-qs-remove]' : null;
      var ids = orderedIds();
      var existing = {};
      reviewList.querySelectorAll('.eqs-line').forEach(function (line) { existing[line.dataset.variantId] = line; });
      if (typingId && existing[typingId] && list[typingId]) {
        var line = existing[typingId];
        var item = list[typingId];
        line.querySelector('.eqs-line__total').textContent = money(item.price * item.qty);
        var lineStep = line.querySelector('[data-qs-step="1"]');
        if (lineStep) lineStep.disabled = item.max !== null && item.max !== undefined && item.qty >= item.max;
        return;
      }
      reviewList.innerHTML = '';
      ids.forEach(function (id) { reviewList.appendChild(reviewLine(id)); });
      if (focusId && focusSelector) {
        var target = reviewList.querySelector('[data-variant-id="' + focusId + '"] ' + focusSelector);
        if (target && !target.disabled) target.focus();
      }
    }

    function toggleReview(open) {
      var show = open === undefined ? reviewPanel.hidden : open;
      if (show) renderReview();
      reviewPanel.hidden = !show;
      reviewButton.setAttribute('aria-expanded', show ? 'true' : 'false');
    }

    function showMessage(text, success) {
      message.textContent = text;
      message.classList.toggle('is-success', Boolean(success));
      message.hidden = false;
    }

    function hideMessage() {
      message.hidden = true;
      message.textContent = '';
    }

    // ---- Adding everything to the cart -------------------------------------------------------
    // One /cart/add.js request carries every line, so the cart gets all of it or none of it.
    // Wire sold by the foot keeps the cut length the cart and wiring pages use.

    // Shopify lists the newest line first, so lines go last to first to read in list order. Spliced
    // wire sends one line per cut; "Splice cut" and the hidden group id keep identical cuts apart.
    function cartLines() {
      var lines = [];
      orderedIds().forEach(function (id) {
        var item = list[id];
        if (item.cuts && item.cuts.length > 1) {
          var group = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
          item.cuts.forEach(function (length, index) {
            lines.push({ id: Number(id), quantity: length, properties: { 'Cut length': length + ' ft', 'Number of cuts': '1', 'Splice cut': (index + 1) + ' of ' + item.cuts.length, '_Splice group': group } });
          });
          return;
        }
        var line = { id: Number(id), quantity: item.qty };
        if (item.unit === 'ft') line.properties = { 'Cut length': item.qty + ' ft', 'Number of cuts': '1' };
        lines.push(line);
      });
      return lines.reverse();
    }

    function setBusy(state, button) {
      busy = state;
      [addAllButton, checkoutButton].forEach(function (control) {
        control.disabled = state;
        if (state && control === button) control.setAttribute('aria-busy', 'true');
        else control.removeAttribute('aria-busy');
      });
    }

    function addAll(checkout) {
      if (busy || !Object.keys(list).length) return;
      var popup = document.querySelector('excel-cart-popup');
      var body = { items: cartLines() };
      var popupSection = popup && popup.dataset.sectionId;
      if (popupSection && !checkout) {
        body.sections = popupSection;
        body.sections_url = popup.dataset.cartUrl || data.cartUrl;
      }
      var summary = {
        count: Object.keys(list).reduce(function (sum, id) { return sum + (list[id].cuts ? list[id].cuts.length : list[id].unit === 'ft' ? 1 : list[id].qty); }, 0),
        cents: totalCents(),
        feet: false
      };
      setBusy(true, checkout ? checkoutButton : addAllButton);
      hideMessage();

      fetch(data.cartAddUrl.replace(/\/$/, '') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (result) {
            if (!response.ok || result.status >= 400) {
              var text = typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : '';
              throw new Error(text || data.labelAddError);
            }
            return result;
          });
        })
        .then(function (result) {
          var ids = Object.keys(list);
          list = {};
          saveList();
          ids.forEach(function (id) { syncRows(id); });
          if (checkout) {
            window.location.assign(data.checkoutUrl);
            return;
          }
          setBusy(false);
          renderBar();
          if (popup && typeof popup.refresh === 'function') {
            Promise.resolve(popup.refresh(result.sections && result.sections[popupSection]))
              .catch(function () {})
              .then(function () { if (typeof popup.showToast === 'function') popup.showToast(summary); });
          } else {
            window.location.assign(data.cartUrl);
          }
        })
        .catch(function (error) {
          setBusy(false);
          showMessage(error.message || data.labelAddError);
        });
    }

    // ---- Loading categories and searches in place --------------------------------------------

    function resultsUrl(source, query, page) {
      var url;
      if (source === 'search') {
        url = new URL(data.searchUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
      } else {
        url = new URL(data.collectionsUrl.replace(/\/$/, '') + '/' + encodeURIComponent(source), window.location.origin);
      }
      if (page > 1) url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', data.resultsSection);
      return url.toString();
    }

    function pageUrl(source, query) {
      var url = new URL(window.location.href);
      url.searchParams.delete('category');
      url.searchParams.delete('q');
      url.searchParams.delete('page');
      if (source === 'search') url.searchParams.set('q', query);
      else if (source) url.searchParams.set('category', source);
      return url.toString();
    }

    function applyMeta() {
      var results = resultsWrap.querySelector('[data-qs-results]');
      if (!results) return;
      var count = Number(results.dataset.count) || 0;
      countLabel.textContent = plural(count, data.labelProductsOne, data.labelProductsMany);
      if (current.source !== 'search') triggerLabel.textContent = results.dataset.title;
      markActive();
    }

    function markActive() {
      var active = null;
      nav.querySelectorAll('[data-qs-category]').forEach(function (link) {
        var on = current.source !== 'search' && link.dataset.qsCategory === current.source && !active;
        if (on) active = link;
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    function scrollToResults() {
      var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var top = resultsWrap.getBoundingClientRect().top - offset - 16;
      if (top < 0) window.scrollBy({ top: top, behavior: 'smooth' });
    }

    function show(source, query, options) {
      options = options || {};
      if (loading) loading.abort();
      if (moreLoading) moreLoading.abort();
      var controller = loading = new AbortController();
      section.classList.add('is-loading');
      resultsWrap.setAttribute('aria-busy', 'true');

      return fetch(resultsUrl(source, query, 1), { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Quick Shop results failed to load');
          return response.text();
        })
        .then(function (html) {
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qs-results]');
          if (!next) throw new Error('Quick Shop results missing');
          resultsWrap.replaceChildren(document.adoptNode(next));
          current = { source: source, query: query || '' };
          if (source !== 'search') lastCategory = source;
          applyMeta();
          syncAllRows();
          setupMore();
          if (options.history === 'push') window.history.pushState({ excelQuickShop: true }, '', pageUrl(source, query));
          else if (options.history === 'replace') window.history.replaceState({ excelQuickShop: true }, '', pageUrl(source, query));
          if (options.scroll) scrollToResults();
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          countLabel.textContent = data.labelLoadError;
        })
        .finally(function () {
          if (loading !== controller) return;
          loading = null;
          section.classList.remove('is-loading');
          resultsWrap.removeAttribute('aria-busy');
        });
    }

    // ---- Loading more as the list scrolls ---------------------------------------------------

    function setupMore() {
      if (moreObserver) moreObserver.disconnect();
      if (moreLoading) moreLoading.abort();
      moreObserver = null;
      moreLoading = null;
      more = resultsWrap.querySelector('[data-qs-more]');
      if (!more) return;
      if ('IntersectionObserver' in window) {
        moreObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
        }, { rootMargin: '0px 0px 800px 0px' });
        moreObserver.observe(more);
      }
    }

    function loadMore() {
      if (!more || moreLoading || loading) return;
      var status = more.querySelector('[data-qs-more-status]');
      var page = Number(more.dataset.nextPage) || 2;
      var controller = moreLoading = new AbortController();
      more.classList.add('is-loading');
      more.classList.remove('is-error');
      status.textContent = data.labelLoading;

      fetch(resultsUrl(current.source, current.query, page), { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('More Quick Shop results failed to load');
          return response.text();
        })
        .then(function (html) {
          if (moreLoading !== controller) return;
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qs-results]');
          var table = resultsWrap.querySelector('[data-qs-list]');
          if (!next || !table) throw new Error('More Quick Shop results missing');
          next.querySelectorAll('[data-qs-list] > .eqs-row').forEach(function (row) {
            if (row.dataset.variantId && table.querySelector('[data-variant-id="' + row.dataset.variantId + '"]')) return;
            table.appendChild(document.adoptNode(row));
            if (row.hasAttribute('data-qs-row')) syncRow(row);
          });
          saveList();
          var nextMore = next.querySelector('[data-qs-more]');
          moreLoading = null;
          more.classList.remove('is-loading');
          status.textContent = '';
          if (nextMore) {
            more.dataset.nextPage = nextMore.dataset.nextPage;
            if (more.getBoundingClientRect().top < window.innerHeight + 800) loadMore();
          } else {
            if (moreObserver) moreObserver.disconnect();
            moreObserver = null;
            more.remove();
            more = null;
          }
        })
        .catch(function (error) {
          if (moreLoading !== controller) return;
          moreLoading = null;
          if (error.name === 'AbortError' || !more) return;
          more.classList.remove('is-loading');
          more.classList.add('is-error');
          status.textContent = data.labelLoadError;
        });
    }

    // ---- Category drawer (tablets and phones) -----------------------------------------------

    var drawerQuery = window.matchMedia('(max-width: 1099px)');

    function openDrawer() {
      previousOverflow = document.body.style.overflow;
      sidebar.classList.add('is-open');
      scrim.hidden = false;
      scrim.classList.add('is-open');
      openCategories.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var active = nav.querySelector('.is-active');
      if (active) active.scrollIntoView({ block: 'center' });
      closeCategoriesButton.focus();
    }

    function closeDrawer(restoreFocus) {
      if (!sidebar.classList.contains('is-open')) return;
      sidebar.classList.remove('is-open');
      scrim.classList.remove('is-open');
      scrim.hidden = true;
      openCategories.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      if (restoreFocus !== false) openCategories.focus();
    }

    openCategories.addEventListener('click', openDrawer);
    section.querySelectorAll('[data-qs-close-categories]').forEach(function (element) {
      element.addEventListener('click', function () { closeDrawer(); });
    });
    drawerQuery.addEventListener('change', function (event) { if (!event.matches) closeDrawer(false); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (sidebar.classList.contains('is-open')) closeDrawer();
        else if (!reviewPanel.hidden) {
          toggleReview(false);
          reviewButton.focus();
        }
        return;
      }
      if (event.key !== 'Tab' || !sidebar.classList.contains('is-open')) return;
      var focusable = Array.prototype.filter.call(sidebar.querySelectorAll('a, button'), function (element) {
        return !element.disabled && element.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // ---- Events ---------------------------------------------------------------------------

    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-qs-category]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      clearTimeout(searchTimer);
      searchInput.value = '';
      searchClear.hidden = true;
      closeDrawer(false);
      if (link.dataset.qsCategory === current.source) {
        scrollToResults();
        return;
      }
      show(link.dataset.qsCategory, '', { history: 'push', scroll: true });
    });

    function runSearch(history) {
      var query = searchInput.value.trim();
      searchClear.hidden = !searchInput.value;
      if (query.length < 2) {
        if (current.source === 'search' && lastCategory) show(lastCategory, '', { history: 'replace' });
        return;
      }
      if (current.source === 'search' && current.query === query) return;
      show('search', query, { history: current.source === 'search' ? 'replace' : history });
    }

    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchClear.hidden = !searchInput.value;
      searchTimer = setTimeout(function () { runSearch('push'); }, 350);
    });
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && searchInput.value) {
        event.stopPropagation();
        searchInput.value = '';
        runSearch('replace');
      }
    });
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(searchTimer);
      runSearch('push');
      searchInput.blur();
    });
    searchClear.addEventListener('click', function () {
      clearTimeout(searchTimer);
      searchInput.value = '';
      runSearch('replace');
      searchInput.focus();
    });

    function stepFrom(control, direction) {
      var holder = control.closest('[data-variant-id]');
      var id = holder.dataset.variantId;
      var item = itemFor(id);
      if (!item) return;
      var qty = list[id] ? list[id].qty : 0;
      var next = qty + direction * item.buttonStep;
      // From zero, + puts in the starting amount (one item, or 100 ft of wire).
      if (qty === 0 && direction > 0) next = item.max !== null && item.max !== undefined ? Math.min(item.start, item.max) : item.start;
      // Stepping below the minimum takes the item off the list.
      if (direction < 0 && next < item.min) next = 0;
      // Stepping footage up from an odd number lands on the next 50.
      if (direction > 0 && item.buttonStep > item.step && qty % item.buttonStep) next = Math.ceil(qty / item.buttonStep) * item.buttonStep;
      if (direction < 0 && item.buttonStep > item.step && qty % item.buttonStep && next > 0) next = Math.floor(qty / item.buttonStep) * item.buttonStep;
      var result = setQuantity(id, next);
      // Back at zero the minus button disables, so focus moves to the quantity box.
      var row = control.closest('[data-qs-row]');
      if (row && result === 0 && document.activeElement === control) row.querySelector('[data-qs-input]').focus();
    }

    section.addEventListener('click', function (event) {
      var spliceOpen = event.target.closest('[data-qs-splice-toggle], [data-qs-cuts-edit]');
      if (spliceOpen) {
        var spliceRow = spliceOpen.closest('[data-qs-row]');
        if (spliceRow.classList.contains('is-splicing')) closeSplice(spliceRow);
        else openSplice(spliceRow);
        return;
      }
      if (event.target.closest('[data-qs-splice-close]')) {
        closeSplice(event.target.closest('[data-qs-row]'));
        return;
      }
      if (event.target.closest('[data-qs-splice-save]')) {
        saveSplice(event.target.closest('[data-qs-row]'));
        return;
      }
      var clearCuts = event.target.closest('[data-qs-cuts-clear]');
      if (clearCuts) {
        var clearRow = clearCuts.closest('[data-qs-row]');
        if (clearRow.classList.contains('is-splicing')) setSpliceOpen(clearRow, false);
        setQuantity(clearRow.dataset.variantId, 0);
        clearRow.querySelector('[data-qs-input]').focus();
        return;
      }
      var addCut = event.target.closest('[data-qs-splice-add]');
      if (addCut) {
        var cutRow = addCut.closest('[data-qs-row]');
        var cutInput = addCutField(cutRow, '');
        labelCuts(cutRow);
        updateSplice(cutRow);
        cutInput.focus();
        return;
      }
      var removeCut = event.target.closest('[data-qs-cut-remove]');
      if (removeCut) {
        var removeRow = removeCut.closest('[data-qs-row]');
        var field = removeCut.closest('.eqs-splice__cut');
        var index = cutInputs(removeRow).indexOf(field.querySelector('input'));
        field.remove();
        labelCuts(removeRow);
        updateSplice(removeRow);
        var remaining = cutInputs(removeRow);
        if (remaining.length) remaining[Math.min(index, remaining.length - 1)].focus();
        return;
      }
      var step = event.target.closest('[data-qs-step]');
      if (step && !step.disabled) {
        stepFrom(step, Number(step.dataset.qsStep));
        return;
      }
      var remove = event.target.closest('[data-qs-remove]');
      if (remove) {
        var line = remove.closest('.eqs-line');
        var sibling = line.nextElementSibling || line.previousElementSibling;
        var siblingId = sibling && sibling.dataset.variantId;
        setQuantity(line.dataset.variantId, 0);
        var target = siblingId && reviewList.querySelector('[data-variant-id="' + siblingId + '"] [data-qs-remove]');
        if (target) target.focus();
        else if (!bar.hidden) reviewButton.focus();
        else searchInput.focus();
        return;
      }
      if (event.target.closest('[data-qs-more-button]')) loadMore();
    });

    section.addEventListener('input', function (event) {
      var cut = event.target.closest('[data-qs-cut-input]');
      if (cut) {
        var cutDigits = cut.value.replace(/\D/g, '');
        if (cutDigits !== cut.value) cut.value = cutDigits;
        updateSplice(cut.closest('[data-qs-row]'));
        return;
      }
      var input = event.target.closest('[data-qs-input]');
      if (!input) return;
      var digits = input.value.replace(/\D/g, '');
      if (digits !== input.value) input.value = digits;
      sizeInput(input);
      var id = input.closest('[data-variant-id]').dataset.variantId;
      var qty = Number(digits);
      // An emptied box settles when it's left (see change below).
      if (!digits) return;
      setQuantity(id, qty, { keepInput: true });
    });

    // Leaving the box settles the number: empty or zero removes the item, others snap to the rules.
    section.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qs-input]');
      if (!input) return;
      var holder = input.closest('[data-variant-id]');
      var id = holder.dataset.variantId;
      var qty = Number(input.value.replace(/\D/g, ''));
      var result = setQuantity(id, qty);
      if (!input.closest('[data-qs-row]') && result > 0) input.value = String(result);
    });

    section.addEventListener('keydown', function (event) {
      // In the cut card, Enter adds the cuts to the list and Esc cancels the draft.
      var card = event.target.closest('[data-qs-splice]');
      if (card && (event.key === 'Escape' || (event.key === 'Enter' && event.target.closest('[data-qs-cut-input]')))) {
        event.preventDefault();
        event.stopPropagation();
        if (event.key === 'Escape') closeSplice(card.closest('[data-qs-row]'));
        else saveSplice(card.closest('[data-qs-row]'));
        return;
      }
      var input = event.target.closest('[data-qs-input]');
      if (!input) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        input.blur();
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        var stepper = input.closest('.eqs-stepper');
        var button = stepper.querySelector('[data-qs-step="' + (event.key === 'ArrowUp' ? '1' : '-1') + '"]');
        if (!button.disabled) stepFrom(button, event.key === 'ArrowUp' ? 1 : -1);
        input.focus();
      }
    });

    reviewButton.addEventListener('click', function () { toggleReview(); });
    clearButton.addEventListener('click', function () {
      var ids = Object.keys(list);
      list = {};
      saveList();
      ids.forEach(function (id) { syncRows(id); });
      renderBar();
      searchInput.focus({ preventScroll: true });
    });
    addAllButton.addEventListener('click', function () { addAll(false); });
    checkoutButton.addEventListener('click', function () { addAll(true); });

    // Items on the list aren't in the cart yet, so leaving the page asks first. Browsers show their
    // own "Leave site?" wording. Adding to the cart or Checkout empties the list before navigating.
    window.addEventListener('beforeunload', function (event) {
      if (!Object.keys(list).length) return;
      event.preventDefault();
      event.returnValue = '';
    });

    // Another tab changed the list.
    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY) return;
      list = readList();
      resultsWrap.querySelectorAll('[data-qs-row]').forEach(function (row) { syncRow(row); });
      renderBar();
      if (!reviewPanel.hidden) renderReview();
    });

    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      var query = params.get('q');
      if (query) {
        searchInput.value = query;
        searchClear.hidden = false;
        show('search', query, {});
      } else {
        searchInput.value = '';
        searchClear.hidden = true;
        var category = params.get('category') || lastCategory;
        if (category && (category !== current.source || current.source === 'search')) show(category, '', {});
      }
    });

    // ---- Start ----------------------------------------------------------------------------

    section.classList.add('is-infinite');
    applyMeta();
    syncAllRows();
    renderBar();
    setupMore();

    var params = new URLSearchParams(window.location.search);
    var startQuery = (params.get('q') || '').trim();
    var startCategory = params.get('category');
    if (startQuery) {
      searchInput.value = startQuery;
      searchClear.hidden = false;
      show('search', startQuery, {});
    } else if (startCategory && startCategory !== current.source && /^[a-z0-9-]+$/.test(startCategory)) {
      show(startCategory, '', {});
    }
  }

  function start() {
    if (!window.fetch || !window.DOMParser || !window.URL) return;
    document.querySelectorAll('[data-excel-quick-shop]').forEach(initQuickShop);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
